<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">

          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <h1>
                <span class="series-PageTitle_Logo">COMPANY</span>
                <span class="series-PageTitle_Title" style="color:#FFF">会社概要</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target promotion-PageTitle-visual" style="background: url(../../../../static/img/company/COMPYANY.jpg) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="company-Profile">
            <div class="company-Profile_Inner">
              <div class="st-Grid_Inner-common company-profile-appear-3-1">
                <h3 class="sw-Section_HeaderS company-profile-appear-3" data-appear="true">
                  <span class="sw-Section_HeaderS-en"><b>COMPANY PROFILE</b></span>
                  <span class="sw-Section_HeaderS-ja"><b>会社概要</b></span>
                </h3>
              </div>
              <div class="company-Profile_List company-profile-appear-4" data-appear="true">
                <dl>
                  <dt>会社名</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <router-link to="/">
                        <p class="company-Profile_List-text">株式会社ロボティクスソリューションズ<br />
                        （英語名Robotics Solutions Co.,Ltd.）
                        </p>
                      </router-link>
                    </div>
                  </dd>
                </dl>
                <dl class="location">
                  <dt>所在地</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <div class="company-Profile_List-text">
                        〒105-0022<br />
                        　東京都港区海岸1丁目2番20号　汐留ビルディング3階
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>設立日</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">令和5年10月18日<br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>資本金</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">1,000万円<br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>代表者</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">代表取締役社長　劉　竑<br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>事業内容</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">システムの受託開発<br />
                      ロボティクスの自動化に関する企画、開発、実施および保守のエンジニアリングサービス<br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt style="display: block;" class="pt-md-5 pt-4">デモセンター
                    <br/><span style="color: red;">「準備中4月1日仮オープン」</span>
                  </dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">〒332-0002<br />
                        　埼玉県川口市弥平2-15-7<br />
                        首都高速川口線加賀ICより車で5分<br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>主要取引銀行</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">みずほ銀行<br class="sp"></p>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </section>

          <section class="company-Profile">
            <div class="company-Profile_Inner pt-0">
              <div class="st-Grid_Inner-common company-profile-appear-7-1">
                <h3 class="sw-Section_HeaderS company-profile-appear-7-2" data-appear="true">
                  <span class="sw-Section_HeaderS-en"><b>BUSINESS PARTNER</b></span>
                  <span class="sw-Section_HeaderS-ja"><b>ビジネスパートナー</b></span>
                </h3>
              </div>
              <div class="company-Profile_List company-profile-appear-8" data-appear="true">
                <dl>
                  <dt class="text-left">株式会社アースワーム</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                        <p class="company-Profile_List-text">
                          英語名：earthworm Co., Ltd.<br /><br />
                          〒１０５−００１３<br />
                          東京都港区浜松町２−２−１５ 浜松町ダイヤハイツ３０３号
                        </p>
                    </div>
                  </dd>
                </dl>
                <dl class="location">
                  <dt class="text-left">南昌阿斯旺信息技术有限责任公司
                  </dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <div class="company-Profile_List-text">
                        英語名：Nanchang Asiwang Information Technology Co.,LTD.<br /><br />
                        〒３３０１０３<br />
                        中国・江西省南昌市红谷滩区嘉言路668号语音服务中心第4层
                      </div>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </section>

          <section class="company-Profile">
            <div class="company-Profile_Inner pt-0">
              <div class="st-Grid_Inner-common company-profile-appear-5-1">
                <h3 class="sw-Section_HeaderS company-profile-appear-5" data-appear="true">
                  <span class="sw-Section_HeaderS-en"><b>ACCESS</b></span>
                  <span class="sw-Section_HeaderS-ja"><b>アクセス</b></span>
                </h3>
              </div>
              <div class="common-appear company-profile-appear-6" data-appear="true">
                <font>
                  <p class="company-Profile_List-text">JR・山手線・京浜東北線 浜松町駅　徒歩2分
                    <br />
                    都営・浅草線・大江戸線 大門駅 徒歩2分
                  </p>
                  <br />
                  <br />
                </font>
                <div class="flex-align-center">
                  <figure>
                    <iframe class="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.8234080266816!2d139.75672317724693!3d35.6567222313173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bc597f1d07b%3A0xee4872f5a2e303bb!2z5pel5pys44CB44CSMTA1LTAwMjIg5p2x5Lqs6YO95riv5Yy65rW35bK477yR5LiB55uu77yS4oiS77yS77yQIOaxkOeVmeODk-ODq-ODh-OCo-ODs-OCsA!5e0!3m2!1sja!2sus!4v1700028411187!5m2!1sja!2sus" width="100%" height="600" allowfullscreen="true"></iframe>
                  </figure>
                </div>
              </div>
            </div>
          </section>

        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList">
            <li class="st-BreadcrumbsList_Item">
              <router-link class="st-BreadcrumbsList_Item-link" to="/">
                <p itemprop="item" aria-current="page"><span itemprop="name">ホーム</span></p>
              </router-link>
            </li>
            <li class="st-BreadcrumbsList_Item">
              <p itemprop="item" aria-current="page"><span itemprop="name">会社情報</span></p>
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      $(".series-PageTitle_Inner").eq(0).addClass('appear')
      $('.company-profile-appear-3').addClass('appear')
      $('.company-profile-appear-3-1').addClass('st-Grid_Inner-common_appear')
      $('.company-profile-appear-4').addClass('appear')
      // element.offsetHeight
      let beforeScollH = 0
      $(document).scroll(() => {

        if (this.$route.path != '/company/profile') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        let differH = scroH - beforeScollH
        let mql = window.matchMedia('(max-width:768px)')

        if (differH === 0) {
          return false
        }
        beforeScollH = scroH

        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          $(".google-map").attr("height", "600")

          if (scroH > 300) {
            $('.series-PageTitle_Inner').eq(0).removeClass('appear')
          } else {
            $('.series-PageTitle_Inner').eq(0).addClass('appear')
          }

          if (scroH > 1280) {
            $('.company-profile-appear-3').removeClass('appear')
            $('.company-profile-appear-3-1').removeClass('st-Grid_Inner-common_appear')
            $('.company-profile-appear-4').removeClass('appear')
          } else {
            $('.company-profile-appear-3').addClass('appear')
            $('.company-profile-appear-3-1').addClass('st-Grid_Inner-common_appear')
            $('.company-profile-appear-4').addClass('appear')
          }

          if (scroH > 500 && scroH < 2000) {
            $('.company-profile-appear-7-1').addClass('st-Grid_Inner-common_appear')
            $('.company-profile-appear-7-2').addClass('appear')
            $('.company-profile-appear-8').addClass('appear')
          } else {
            $('.company-profile-appear-7-1').removeClass('st-Grid_Inner-common_appear')
            $('.company-profile-appear-7-2').removeClass('appear')
            $('.company-profile-appear-8').removeClass('appear')
          }

          if (scroH > 1100 && scroH < 2100) {
            $('.company-profile-appear-5').addClass('appear')
            $('.company-profile-appear-5-1').addClass('st-Grid_Inner-common_appear')
          } else {
            $('.company-profile-appear-5').removeClass('appear')
            $('.company-profile-appear-5-1').removeClass('st-Grid_Inner-common_appear')
          }

          if (scroH > 1100) {
            $('.company-profile-appear-6').addClass('appear')
          } else {
            $('.company-profile-appear-6').removeClass('appear')
          }
        } else {
          $(".google-map").attr("height", "400")
          $('.company-profile-appear-1').addClass('appear')
          $('.company-profile-appear-1-1').addClass('st-Grid_Inner-common_appear')
          $('.company-profile-appear-2').addClass('appear')
          $('.company-profile-appear-3').addClass('appear')
          $('.company-profile-appear-3-1').addClass('st-Grid_Inner-common_appear')
          $('.company-profile-appear-4').addClass('appear')
          $('.company-profile-appear-5').addClass('appear')
          $('.company-profile-appear-5-1').addClass('st-Grid_Inner-common_appear')
          $('.company-profile-appear-6').addClass('appear')
          $('.company-profile-appear-7-1').addClass('st-Grid_Inner-common_appear')
          $('.company-profile-appear-7-2').addClass('appear')
          $('.company-profile-appear-8').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/company.css">
</style>




// WEBPACK FOOTER //
// src/components/pages/company/profile.vue